import * as core from '../../../../../../../core'

import { query } from './edit-proposal-modal.query'

export const RESOURCE = {
  payload: {
    alias: 'edit.proposal.modal',
    description: 'Modal used to edit proposals',
    name: 'Edit Proposal Modal',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
